import { createClient, SupabaseClient } from '@supabase/supabase-js'
import { env, isSupabaseConfigured } from '../config/env'

/**
 * Cliente de Supabase para Team Spain v0.
 *
 * REGLA DE SEGURIDAD CRÍTICA:
 * Este cliente corre en el navegador. Utiliza exclusivamente la clave anónima (anon public key).
 * NUNCA importar ni utilizar la service_role_key en el cliente frontend.
 */

let supabaseInstance: SupabaseClient | null = null

export function getSupabaseClient(): SupabaseClient | null {
  if (!isSupabaseConfigured()) {
    return null
  }

  if (!supabaseInstance) {
    const key = env.supabasePublishableKey || env.supabaseAnonKey
    supabaseInstance = createClient(env.supabaseUrl, key, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    })
  }

  return supabaseInstance
}

export const supabase = getSupabaseClient()
